module.exports = __webpack_public_path__ + "img/submitPrompt1.66fff485.png";